import { connect } from 'react-redux';
import { getSsoRoles } from 'ducks/ssoGroupManagement';
import SsoGroupAdd from './SsoGroupAdd';

const mapStateToProps = (state) => ({
  ajaxStatus: state.ajax,
  localisation: state.localisation,
  appLoading: state.meta.appLoading,
  roles: state.ssoGroups.roles,
});

const mapDispatchToProps = {
  getSsoRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoGroupAdd);
